// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"9":"96e9af4f","305":"96e9af4f","385":"883dab7a","996":"96e9af4f"}[chunkId] + ".chunk.css";
};